var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSedan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 700,
    viewBox: "0 0 700 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.877 450C149.097 450 167.92 431.606 167.92 408.916C167.92 386.226 149.097 367.832 125.877 367.832C102.657 367.832 83.834 386.226 83.834 408.916C83.834 431.606 102.657 450 125.877 450Z",
    fill: "#09081A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M447.09 450C470.31 450 489.133 431.606 489.133 408.916C489.133 386.226 470.31 367.832 447.09 367.832C423.87 367.832 405.047 386.226 405.047 408.916C405.047 431.606 423.87 450 447.09 450Z",
    fill: "#09081A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.561 425.545H607.642C619.985 425.545 629.991 415.767 629.991 403.706V332.898H104.561V425.545Z",
    fill: "#09081A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M654.093 377.74V395.688C654.093 400.019 651.519 403.962 647.484 405.777L626.596 415.063C626.596 415.063 628.162 395.04 620.73 377.195C618.235 371.203 614.731 365.445 609.794 360.777C607.14 358.287 604.061 356.082 600.452 354.37C600.425 354.37 600.398 354.344 600.372 354.344C594.904 351.751 588.242 350.194 580.173 350.194C577.599 350.194 575.183 350.402 572.901 350.791C570.538 351.154 568.335 351.751 566.292 352.477C566.185 352.529 566.132 352.555 566 352.607C565.761 352.684 565.469 352.814 565.203 352.918C563.239 353.696 561.408 354.63 559.709 355.667C551.614 360.725 546.279 368.688 542.802 377.195C535.343 395.273 536.166 415.763 536.166 415.763H359.315C359.315 415.763 359.342 415.4 359.342 414.726C359.501 410.394 359.66 392.887 352.918 377.195C348.619 367.209 341.532 357.95 329.853 353.307C324.89 351.336 319.077 350.194 312.282 350.194C309.787 350.194 307.425 350.376 305.169 350.713C304.797 350.765 304.399 350.817 304.001 350.921C291.632 353.048 283.431 360.102 278.043 368.817C271.991 378.57 269.47 390.397 268.434 399.734C268.434 399.734 268.434 399.734 268.434 399.76C267.957 403.962 267.797 407.697 267.771 410.472C267.744 413.766 267.877 415.763 267.877 415.763H55.0879V374.809C55.0879 370.114 55.6718 365.523 56.7866 361.166C58.7773 353.255 62.4666 345.993 67.4566 339.742L67.5893 339.56L68.8102 338.082C77.5692 327.915 89.9379 320.73 104.191 318.474L175.988 307.165L277.99 254.902C284.254 251.686 291.261 250 298.348 250H496.432C556.365 250 596.709 295.805 642.017 326.722L646.317 329.652C646.317 329.652 656.217 341.039 649.422 356.886C649.422 356.886 649.422 357.561 649.475 358.572C649.634 360.751 650.165 364.512 651.705 367.391C653.403 370.555 654.093 374.16 654.093 377.74Z",
    fill: "url(#paint0_linear_4939_615)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.289 307.068H342.775L390.498 256.75H298.582C292.132 256.75 285.762 258.306 280.082 261.315L193.289 307.068Z",
    fill: "#09081A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M409.878 256.75H473.208V311.114H356.607L400.641 260.9C402.95 258.28 406.321 256.75 409.878 256.75Z",
    fill: "#09081A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M593.043 311.114H488.732V256.75C500.384 256.75 512.435 258.462 524.14 261.548C528.705 262.767 533.27 264.194 537.703 265.802C548.32 269.667 558.459 274.647 567.536 280.508C575.818 285.877 583.223 292.932 590.894 299.261C591.849 300.039 593.787 302.036 595.99 304.189C598.591 306.756 596.733 311.114 593.043 311.114Z",
    fill: "#09081A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M271.485 407.227V413.815C271.485 419.832 266.495 424.734 260.311 424.734H56.1743C49.9899 424.76 45 419.832 45 413.815V407.227C45 401.546 49.4326 396.878 55.1126 396.333C55.4576 396.307 55.8027 396.281 56.1743 396.281H260.311C263.496 396.281 266.389 397.578 268.433 399.705C268.433 399.705 268.433 399.705 268.433 399.731C270.344 401.676 271.485 404.322 271.485 407.227Z",
    fill: "#09081A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M649.42 356.886C649.42 356.886 649.42 357.534 649.499 358.572C645.385 358.572 642.041 355.304 642.041 351.284V326.695L646.341 329.626C646.314 329.652 656.241 341.038 649.42 356.886Z",
    fill: "#067244"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M373.354 250L313.926 307.061L280.032 312.43C256.515 316.165 236.847 331.987 228.566 353.826L212.429 396.31L205.023 415.763L201.626 424.763H56.1743C49.9899 424.763 45 419.835 45 413.818V407.23C45 401.55 49.4326 396.881 55.1126 396.336V374.809C55.1126 370.114 55.6965 365.523 56.7848 361.14C58.802 353.255 62.4648 345.967 67.4547 339.716L67.5875 339.534L68.8084 338.082C77.5673 327.915 89.936 320.73 104.189 318.474L175.986 307.165L277.988 254.902C284.278 251.686 291.259 250 298.372 250H373.354Z",
    fill: "url(#paint1_linear_4939_615)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M312.73 450C335.95 450 354.773 431.606 354.773 408.916C354.773 386.226 335.95 367.832 312.73 367.832C289.511 367.832 270.688 386.226 270.688 408.916C270.688 431.606 289.511 450 312.73 450Z",
    fill: "#333333"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M312.733 432.599C326.117 432.599 336.966 421.997 336.966 408.919C336.966 395.84 326.117 385.238 312.733 385.238C299.35 385.238 288.5 395.84 288.5 408.919C288.5 421.997 299.35 432.599 312.733 432.599Z",
    fill: "#F2F2F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M581.471 450C604.69 450 623.514 431.606 623.514 408.916C623.514 386.226 604.69 367.832 581.471 367.832C558.251 367.832 539.428 386.226 539.428 408.916C539.428 431.606 558.251 450 581.471 450Z",
    fill: "#333333"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M581.473 432.599C594.857 432.599 605.706 421.997 605.706 408.919C605.706 395.84 594.857 385.238 581.473 385.238C568.09 385.238 557.24 395.84 557.24 408.919C557.24 421.997 568.09 432.599 581.473 432.599Z",
    fill: "#F2F2F2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M626.222 377.197H620.728C618.233 371.205 614.73 365.447 609.793 360.779C607.138 358.289 604.06 356.084 600.45 354.372C600.423 354.372 600.397 354.346 600.37 354.346C594.903 351.752 588.24 350.196 580.172 350.196C577.597 350.196 575.182 350.404 572.899 350.793C570.537 351.156 568.334 351.752 566.29 352.479C566.184 352.531 566.131 352.557 565.998 352.608C565.759 352.686 565.467 352.816 565.202 352.92C563.238 353.698 561.406 354.632 559.707 355.669C551.612 360.727 546.277 368.689 542.8 377.197H352.917C348.617 367.211 341.53 357.951 329.852 353.309L343.308 334.556C349.227 326.308 358.889 321.406 369.214 321.406H597.344C604.378 321.406 611.173 323.818 616.588 328.202C619.374 330.484 621.577 333.285 623.117 336.398C624.656 339.51 625.506 342.934 625.585 346.487L626.222 377.197Z",
    fill: "url(#paint2_linear_4939_615)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M343.734 333.96C349.388 326.075 358.598 321.406 368.445 321.406H597.346",
    stroke: "#09081A",
    strokeWidth: 2.65424,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M274.857 374.812H55.1133",
    stroke: "#09081A",
    strokeWidth: 2.65424,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M176.678 362.225H87.416L96.0422 336.34H185.304L176.678 362.225Z",
    fill: "#09081A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M258.058 332.867L256.147 339.17C252.192 352.216 239.93 361.164 226.022 361.164H184.244L188.464 347.988C191.331 339.014 199.851 332.893 209.512 332.893H258.058V332.867Z",
    fill: "url(#paint3_radial_4939_615)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9352 347.859L81.8391 361.165H56.7832C58.7739 353.28 62.4367 345.992 67.4532 339.741L67.5859 339.585L68.8068 338.133H80.0077C85.1834 338.107 88.7401 343.139 86.9352 347.859Z",
    fill: "url(#paint4_radial_4939_615)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4939_615",
    x1: 354.6,
    y1: 252.735,
    x2: 354.6,
    y2: 457.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FFFBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5017,
    stopColor: "#05D585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B06B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4939_615",
    x1: 264.129,
    y1: 373.628,
    x2: 166.308,
    y2: 301.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4939_615",
    x1: 478.046,
    y1: 308.959,
    x2: 478.046,
    y2: 375.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1893,
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3155,
    stopColor: "#00180F",
    stopOpacity: 0.2533
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5833,
    stopColor: "#015736",
    stopOpacity: 0.1542
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9683,
    stopColor: "#02BA73",
    stopOpacity: 0.0117
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02C378",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4939_615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(221.15 347.016) scale(28.0302 27.391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4939_615",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.1029 349.626) scale(13.6653 13.3536)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSedan);
export default __webpack_public_path__ + "static/media/Sedan.c1192231.svg";
export { ForwardRef as ReactComponent };